import React, { useRef } from "react";
import styled from "styled-components";
import { Modal } from "../reusables/Modal";
import { useVisibility } from "../../assets/utils/hooks/useVisibility";
import useOutsideClose from "../../assets/utils/hooks/useOutsideClose";
import ParentElement from "../hoc/withParentElementSwitch";

export default function MediaCard({ data }) {
	const {
		imageSource,
		// imageName,
		section,
		title,
	} = data;

	const { isVisible, toggle } = useVisibility();
	let menuRef = useRef();
	useOutsideClose(menuRef, toggle);

	return (
		<>
			<MediaCardContainer onClick={toggle}>
				<img src={imageSource[0]} alt="bullet" />

				<div className="details">
					<span>{section}</span>
					<p>{title}</p>
				</div>
			</MediaCardContainer>

			<Modal isVisible={isVisible} toggle={toggle} closable>
				<ModalContentContainer ref={menuRef}>
					{ParentElement(
						imageSource?.map((source) => (
							<div
								key={source}
								className={
									imageSource.length > 1 && "carousel-item"
								}
							>
								<img
									src={source}
									alt="bullet"
									width="100%"
									height="100%"
								/>
							</div>
						)),
						imageSource.length,
						true
					)}
				</ModalContentContainer>
			</Modal>
		</>
	);
}

const MediaCardContainer = styled.li`
	position: relative;
	width: 100%;
	height: 100%;
	margin-bottom: 0 !important;
	overflow: hidden;

	img {
		width: 100%;
		height: 345px;
		transition: transform 1.5s ease;
		object-fit: cover;
	}

	.details {
		position: absolute;
		top: 0;
		right: 0;
		display: none;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
		width: 100%;
		height: 100%;
		padding: 1.8rem;
		background-color: rgba(0, 0, 0, 0.6);
		transition: display 350ms;

		z-index: 1;

		span {
			display: block;
			width: fit-content;
			padding: 8px 15px;
			margin-bottom: 10px;
			background-color: yellow;
			font-size: 0.8rem;
			text-transform: uppercase;
			font-weight: bold;
		}

		p {
			margin-bottom: 0 !important;
			color: white;
			font-size: 1.3rem;
			line-height: normal;
			font-weight: bold;
		}
	}

	&:hover {
		img {
			transform: scale(1.5);
		}

		.details {
			display: flex;
		}
	}

	@media (min-width: 768px) {
	}
`;

const ModalContentContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;

	ul {
		display: flex;
		justify-content: center;
		align-items: center;
		max-width: 612px;
		max-height: 408px;
		overflow: hidden;
	}

	.carousel {
		max-width: 612px;
		max-height: 408px;

		.carousel-inner {
			width: 100%;
			max-height: 408px;

			.carousel-item {
				width: 100%;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	@media (min-width: 768px) {
	}
`;
